import type { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';

import { i18n as routesI18n } from 'src/hooks/use-imago-mp-routes.i18n';

import { DetailsSection } from './sections/DetailsSection';
import { SubscriptionsSection } from './sections/subscriptions-section/SubscriptionsSection';
import { UsersSection } from './sections/users-section/UsersSection';
import { WorkspacesSection } from './sections/workspaces-section/WorkspacesSection';

export interface InstanceSection {
    /** Unique id used as the DOM `id` attribute for scroll-spy targeting. */
    id: string;
    label: MessageDescriptor;
    element: ReactNode;
    /** If true, the page won't render a section heading (the component provides its own). */
    hideHeading?: boolean;
}

/**
 * Single source of truth for the Instance Detail page sections. Each entry
 * is rendered inline on the page and observed by the scroll-spy hook.
 * The sidebar and section headings derive from this list automatically.
 */
export const INSTANCE_SECTIONS: readonly InstanceSection[] = [
    {
        id: 'details',
        label: routesI18n.instanceSectionDetails,
        element: <DetailsSection />,
    },
    {
        id: 'users',
        label: routesI18n.instanceSectionUsers,
        element: <UsersSection />,
        hideHeading: true,
    },
    {
        id: 'subscriptions',
        label: routesI18n.instanceSectionSubscriptions,
        element: <SubscriptionsSection />,
        hideHeading: true,
    },
    {
        id: 'workspaces',
        label: routesI18n.instanceSectionWorkspaces,
        element: <WorkspacesSection />,
        hideHeading: true,
    },
];
